import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ManagerCallDoArea = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <Wrapper>
      <div className="call-do-action-area">
        <div className="container">
          <div className="row align-items-center call-do-action-bg">
            <div className="col-lg-6 col-md-12">
              <div className="section-title two">
                <h1>Eque Heritage Hotel & Resort</h1>
                <h1 className="fs-3">Saidpur, Nilphamari</h1>
              </div>

              <div className="call-do-action-author">
                <div className="call-do-action-author-thumb">
                  <img
                    // src="/assets/images/home-1/call-do-action-img.png"
                    src="/assets/images/home-1/md. masud rana.jpg"
                    alt=""
                    style={{ width: "90px", height: "90px" }}
                  />
                </div>
                <div className="call-do-action-content">
                  <h4>Mr. Masud Rana</h4>
                  <p>General Manager</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              {/* <div className="call-do-action-video">
              <Link
                className="video-vemo-icon venobox vbox-item"
                data-vbtype="youtube"
                data-autoplay="true"
                target="_blank"
                to="https://www.youtube.com/watch?v=e6R6VsgD8yQ&amp;t=179s"
              >
                <i className="bi bi-play"></i>
              </Link>
            </div> */}

              <div className="call-do-action-video">
                {!isPlaying ? (
                  <Link
                    className="video-vemo-icon venobox vbox-item"
                    data-vbtype="video"
                    data-autoplay="true"
                    target="_blank"
                    href="/assets/video/eque-video-1.MP4"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsPlaying(true);
                    }}
                  >
                    <i className="bi bi-play"></i>
                  </Link>
                ) : (
                  <div className="video-modal">
                    <video width="600" controls autoPlay className="heightt">
                      <source
                        src="/assets/video/eque-video-1.MP4"
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                    <button
                      className="close-btn"
                      onClick={() => setIsPlaying(false)}
                    >
                      ✖
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.section`
  .video-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.8);
    padding: 20px;
    border-radius: 10px;
    z-index: 1000;
  }

  .video-modal video {
    width: 600px;
    max-width: 100%;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    border: none;
    cursor: pointer;
  }

  @media screen and (max-width: 425px) {
    .video-modal video {
      height: 250px !important;
    }
  }

  @media screen and (max-width: 375px) {
    .video-modal video {
      height: 200px !important;
    }
  }
  @media screen and (max-width: 320px) {
    .video-modal video {
      height: 180px !important;
    }
  }

  /* ========== */
  /* .call-do-action-bg {
    background: url(/assets/images/about-video-img/about-video-img-3.jpg)
      no-repeat center center;
    background-size: cover;
    padding: 73px 58px 66px;
    margin-top: -90px;
    min-height: 400px;
  }

  .dark .call-do-action-bg {
    background: url(/assets/images/home-1/dark-img.jpg) no-repeat center center;
    background-size: cover;
  }

  @media screen and (max-width: 768px) {
    .call-do-action-bg {
      min-height: 300px;
    }
  }
  @media screen and (max-width: 480px) {
    .call-do-action-bg {
      min-height: 250px;
    }
  } */
`;

export default ManagerCallDoArea;
